import * as loginCall from "../offline/controller/login";
import * as sessionCall from "../offline/controller/sessions";
import * as systemCall from "../offline/controller/settings";
import * as billingCall from "../offline/controller/billing";
import * as invoiceCall from "../offline/controller/invoice";

export const routeToFunction = (baseurl, url, data) => {
  if (url == baseurl + "vendor/register-mobile") {
    return loginCall.Auth(data);
  } else if (url == baseurl + "vendor/login") {
    return loginCall.Login(data);
  } else if (url == baseurl + "vendor/logout") {
    return loginCall.Logout(data);
  } else if (url == baseurl + "vendor/opening-balance") {
    return sessionCall.openSession(data);
  } else if (url == baseurl + "vendor/closing-balance") {
    return sessionCall.closeSession(data);
  } else if (url == baseurl + "vendor/get-settings") {
    return systemCall.getSetting(data);
  } else if (url == baseurl + "product-details") {
    return billingCall.checkProductInCart(data);
  } else if (url == baseurl + "cart-details") {
    return billingCall.cartDetails(data);
  } else if (url == baseurl + "remove-product-from-cart") {
    return billingCall.removeProduct(data);
  } else if (url == baseurl + "product-qty-update") {
    return billingCall.updateProduct(data);
  } else if (url == baseurl + "get-profile") {
    return billingCall.getCustomer(data);
  } else if (url == baseurl + "vendor/login-for-customer") {
    return billingCall.tagCustomer(data);
  } else if (url == baseurl + "vendor/un-tag-customer") {
    return billingCall.unTagCustomer(data);
  } else if (url == baseurl + "process-to-payment") {
    if (
      (data.hasOwnProperty("data") &&
        data.data.hasOwnProperty("transaction_type") &&
        data.data.transaction_type == "on_account_deposit") ||
      (data.hasOwnProperty("data") &&
        data.data.hasOwnProperty("trans_sub_type") &&
        data.data.trans_sub_type == "Credit-Note") ||
      (data.hasOwnProperty("data") &&
        data.data.hasOwnProperty("trans_sub_type") &&
        data.data.trans_sub_type == "Refund-CN")
    )
      return;
    return billingCall.createOrder(data);
  } else if (url == baseurl + "save-payment") {
    if (
      (data.hasOwnProperty("data") &&
        data.data.hasOwnProperty("transaction_type") &&
        data.data.transaction_type == "on_account_deposit") ||
      (data.hasOwnProperty("data") &&
        data.data.hasOwnProperty("trans_sub_type") &&
        data.data.trans_sub_type == "Credit-Note") ||
      (data.hasOwnProperty("data") &&
        data.data.hasOwnProperty("trans_sub_type") &&
        data.data.trans_sub_type == "Refund-CN")
    )
      return;
    return billingCall.savePayment(data);
  } else if (url == baseurl + "get-print-receipt") {
    return invoiceCall.getPrintReceipt(data);
  } else if (url == baseurl + "my-orders") {
    if (data.hasOwnProperty("search_term") && data.search_term != "") {
      return invoiceCall.offlineSearch(data);
    }
    return invoiceCall.invoiceHistory(data);
  } else if (url == baseurl + "order-details") {
    return invoiceCall.orderDetails(data);
  } else if (url == baseurl + "get-carry-bags") {
    return billingCall.getCarryBags(data);
  } else if (url == baseurl + "save-carry-bags") {
    return billingCall.saveCarryBags(data);
  } else if (url == baseurl + "print_ack") {
    return invoiceCall.printAcknowledgement(data);
  } else if (url == baseurl + "vendor/order-recall") {
    return invoiceCall.orderRecall(data);
  } else if (url == baseurl + "get-duplicate-receipt") {
    return invoiceCall.getPrintReceipt(data);
  } else if (url == baseurl + "manual-discount") {
    if (data.remove_discount == "0") {
      return billingCall.setManualDiscount(data);
    } else if (data.remove_discount == "1") {
      return billingCall.removeManualDiscount(data);
    }
  }
};
